import { jsx as _jsx } from "react/jsx-runtime";
import { FFContext } from '../context/FFContext';
export function withFeatureFlags(WrappedComponent) {
    return (props) => (_jsx(FFContext.Consumer, { children: ({ flags, loading }) => (_jsx(WrappedComponent, { flags: flags, loading: loading, ...props })) }));
}
